"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Access = void 0;
const privilege_1 = require("./privilege/privilege");
const role_1 = require("./role/role");
const roles_1 = require("./role/roles");
const privileges_1 = require("./privilege/privileges");
const generic_entity_1 = require("../../../abstracts/generic-entity");
/**
 * A specific `Access` client for managing roles and privileges.
 * Use this client to query or mutate data for a particular tenant
 */
class Access extends generic_entity_1.Entity {
    constructor(client, debug) {
        super(client, debug);
        this.roles = new roles_1.Roles(this, this.debug);
        this.privileges = new privileges_1.Privileges(this, this.debug);
    }
    /** Gets specific role */
    role(roleId) {
        return new role_1.Role(this, roleId, this.debug);
    }
    /** Gets specific privilege */
    privilege(privilegeId) {
        return new privilege_1.Privilege(this, privilegeId, this.debug);
    }
}
exports.Access = Access;
